<template>
    <div class="cc-pickup-date" @click.prevent.stop>
        <div class="cc-pickup-date__header">
          <label class="cc-label cc-label--text">{{ translations['Change pickup date'] }}</label>
          <date-picker :value="pickupDate" :disabled-date="notBefore" class="cc-input cc-input--text" valueType="format" format="DD. MM. YYYY" @pick="closeWidget"></date-picker>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/cs';

export default {
  components: {
    DatePicker
  },
  computed: {
    ...mapState({
      translations: state => state.translations,
      shaimBalikNaPostu: state => state.shaimBalikNaPostu,
      pickupDate: state => state.pickupDate,
      pickupDateDelay: state => state.config.pickupDateDelay,
    }),
  },
  data: function () {
    return {
      shouldWidgetBeShown: false,

    };
  },
  methods: {
    closeWidget: function (e) {
      if (this.pickupDate === '') {
        this.$emit('closeWithoutParcelShop');
      }
      this.$store.commit('SET_PICKUP_DATE', e.toLocaleDateString('cs-CZ', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false }));
      this.$emit('selectCarrier', this.carrier)
    },
    notBefore(date) {
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      currentDate.setDate(currentDate.getDate()+this.pickupDateDelay);
      return date < currentDate;
    },
  },
  mounted() {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate()+this.pickupDateDelay);
    let pickupDate = currentDate.toLocaleDateString('cs-CZ', { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false });
    this.$store.commit('SET_PICKUP_DATE', pickupDate);
  },
  props: [
    'carrier',
    'selectedCarrier',
  ],
};
</script>

<style lang="scss" scoped="scoped">
  @import "../scss/popups";
  @import "../scss/tables";
  #app {
    .cc-table {
      margin-top: 1rem;
    }
  }
  #app .cc-table__td {
    padding: 0.5rem 1rem;
  }
  .cc-input.cc-input--text {
    padding: 1rem;
  }
  .cc-pickup-date .cc-table__tr {
    border-top: 1px solid #eeeeee;
  }
  .cc-button {
    white-space: nowrap;
  }
</style>
